// extracted by mini-css-extract-plugin
module.exports = {"creditsWrapper":"Credits_creditsWrapper__3o1wD","input":"Credits_input__NVOhD"};